import React from "react";
import { notification } from "antd";
//import { DeleteOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
//import { Button, Table } from "antd";
//import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { IHomeProps } from "../../models/interface";
import {
  selectCart,
  updateShoppingCart,
  deleteShoppingCartItem,
  applyVoucherCode,
  applyReferralCode,
} from "../../redux/reducers/slice/cart";
import {
  checkVoucherCode,
  checkReferralCode,
  refreshShoppingCart,
} from "../../services/shoppingCart";

import * as GTM from "../../components/tracking/GTM";
// import {
//   encryptPaymentRequest,
//   getPayooInfo,
// } from "../../redux/reducers/slice/payment";
//import { selectCart } from "../../redux/reducers/slice/cart";
//import {
//  encryptPaymentRequest,
//  getPayooInfo,
//} from "../../redux/reducers/slice/payment";
import ShoppingCartItem from "./item";
import ShoppingCartSummary from "./shoppingCartSummary";
// import numeral from "numeral";
import { setTitlePage } from "../../utils/helper";
import { IShoppingCartItem } from "../../models/IShoppingCartModel";
import "./style.scss";
import GiftItem from "./giftItem";
import { InfoCircleOutlined } from "@ant-design/icons";

const ShoppingCart = (props: IHomeProps) => {
  const { t, history } = props;
  const carts = useSelector(selectCart);
  const [gifts, setGifts] = React.useState<any>([]);
  const [isSendEventTracking, setIsSendEventTracking] =
    React.useState<boolean>(false);
  const [isExpiredVoucherCode, setIsExpiredVoucherCode] =
    React.useState<boolean>(false);
  const dispatch = useDispatch();

  const isEmpty = !(carts && carts.items && carts.items.length != 0);

  const el: HTMLDivElement | null = document.querySelector(
    ".shopping-cart-footer-container"
  );

  React.useEffect(() => {
    setTitlePage(t("shopping_cart_title"));
    window.addEventListener("scroll", onHandleScroll);

    return () => {
      window.removeEventListener("scroll", onHandleScroll);
    };
  }, []);

  React.useEffect(() => {
    refreshShoppingCart();
  }, []);

  React.useEffect(() => {
    if (carts && carts.items && carts.items.length) {
      setGifts(
        carts.items.filter(
          (item) => item.gift_promotions && item.gift_promotions.length
        )
      );
    }
    if (
      carts &&
      carts.order_voucher &&
      carts.order_voucher.code &&
      carts.order_voucher.expire_date
    ) {
      const expireDate = new Date(carts.order_voucher.expire_date).getTime();
      const today = new Date().getTime();

      setIsExpiredVoucherCode(today > expireDate);
    } else {
      setIsExpiredVoucherCode(false);
    }
    if (carts?.items && !isSendEventTracking) {
      const products = carts.items.map((sci) => {
        let unit_price = sci.product?.feature?.price_promotion
          ? parseInt(sci.product?.feature?.price_promotion?.replaceAll(".", ""))
          : 0;
        return {
          name: sci.product.name,
          id: sci.product.code,
          price: sci.product?.feature?.price
            ? parseInt(sci.product?.feature?.price?.replaceAll(".", ""))
            : 0,
          category: sci.product?.category_name,
          variant: sci.product?.feature?.spec,
          quantity: sci.quantity,
          promotion: "",
          discount_price: sci.product?.feature?.price_save
            ? parseInt(sci.product?.feature?.price_save.replaceAll(".", ""))
            : 0,
          unit_price: unit_price,
          subtotal_amount: unit_price * sci.quantity,
        };
      });
      GTM.trackingViewCart(products);
      setIsSendEventTracking(true);
    }
  }, [carts]);

  const onHandleScroll = (e: any) => {
    const arrowDown: any = document.querySelector(
      ".shopping-cart-footer-arrow-down"
    );
    const hideArrow: any = document.querySelector(".hide-arrow");
    const cartContent: any = document.querySelector(".shopping-cart-container");

    if (cartContent) {
      if (window.pageYOffset > cartContent.offsetHeight - 500 && arrowDown) {
        arrowDown.classList.add("hide-arrow");
      } else if (hideArrow) {
        hideArrow.classList.remove("hide-arrow");
      }
    }
  };

  const handleChangeShoppingCartItem = (item: IShoppingCartItem) => {
    dispatch(updateShoppingCart(item));
  };

  const handleDeleteShoppingCartItem = (item: IShoppingCartItem) => {
    dispatch(deleteShoppingCartItem(item));
  };

  const handleChangeReferralCode = (value: string) => {
    if (!value || !value.trim()) {
      dispatch(applyReferralCode(undefined));
      return;
    }

    checkReferralCode(value.trim())
      .then((rs) => {
        dispatch(applyReferralCode(rs.data));
      })
      .catch((err) => {
        if (err) {
          notification.error({
            message: err.message,
          });
        }
      });
  };

  const handleChangeVoucherCode = (value: string) => {
    if (!value || !value.trim()) {
      dispatch(applyVoucherCode(undefined));
      return;
    }

    checkVoucherCode(value.trim())
      .then((rs) => {
        if (rs.data) {
          dispatch(applyVoucherCode(rs.data));
          notification.info({
            message: rs.data.name,
          });
        } else {
          notification.error({
            message: rs.statusText,
          });
        }
      })
      .catch((err) => {
        if (err) {
          notification.error({
            message: err.message,
          });
        }
      });
  };

  const checkGiftHaveReselect = (gifts: any = []) => {
    let rs = false;

    if (!gifts.length) {
      return rs;
    }

    gifts.forEach((item: any) => {
      if (item.gift_promotions && item.gift_promotions.length) {
        item.gift_promotions.forEach((gift: any) => {
          if (gift.options && gift.options.length) {
            rs = true;
          }
        });
      }
    });
    return rs;
  };

  return (
    <div className="kd-page-shopping-cart">
      {!isEmpty ? (
        <div
          className="shopping-cart-container"
          style={{
            minHeight: `calc(100vh - ${
              el && el.offsetHeight ? el.offsetHeight + 60 : 220
            }px)`,
          }}>
          <div className="shopping-cart-left-container">
            <div className="shopping-cart-left-wrapper">
              <label className="shopping-cart-main-title main-title">
                {t("shopping_cart_title")}
              </label>
              <div className="shopping-cart-items-container">
                {carts.items?.map((item, index) => (
                  <ShoppingCartItem
                    key={index}
                    item={item}
                    history={history}
                    onDeleteShoppingCartItem={(sci: IShoppingCartItem) =>
                      handleDeleteShoppingCartItem(sci)
                    }
                    onChangeShoppingCartItem={(sci: IShoppingCartItem) =>
                      handleChangeShoppingCartItem(sci)
                    }
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="shopping-cart-right-container">
            <div className="shopping-cart-right-wrapper">
              {gifts.length ? (
                <label className="shopping-cart-gift-title sub-title">
                  {t("shopping_cart_gifts_title")}
                </label>
              ) : null}
              <div className="shopping-cart-gifts-container">
                {carts.items?.map((item, index) => (
                  <GiftItem key={`gift-item-${index}`} item={item} />
                ))}
              </div>
            </div>
            {checkGiftHaveReselect(gifts) ? (
              <div className="cart-note sub-content">
                <span className="sub-content">
                  <InfoCircleOutlined />
                </span>{" "}
                Quý khách có thể chọn lại quà tặng hoặc màu sắc hoa văn
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div className="kd-cart-empty-wrap">
          <img
            src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/imgs/empty-box-animation.gif"
            alt=""
          />
          <span className="sub-title">
            Chưa có sản phẩm nào trong giỏ hàng!
          </span>
        </div>
      )}
      {!isEmpty && (
        <div className="shopping-cart-footer-container">
          <div className="shopping-cart-footer-left-container">
            <div className="shopping-cart-footer-arrow-down">
              <img
                src="https://kdstore.s3-ap-southeast-1.amazonaws.com/static/icons/icon_arrow3-74.svg"
                alt=""
              />
            </div>
            <ShoppingCartSummary
              carts={carts}
              t={t}
              history={history}
              handleChangeReferralCode={handleChangeReferralCode}
              handleChangeVoucherCode={handleChangeVoucherCode}
              isExpiredVoucherCode={isExpiredVoucherCode}
            />
          </div>
          <div className="shopping-cart-footer-right-container">
            <div className="shopping-cart-footer-right-wrapper">
              {/* SP mua kèm */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(ShoppingCart);
